import { render, staticRenderFns } from "./PICMacrocategorie.vue?vue&type=template&id=674a93dc&scoped=true"
import script from "./PICMacrocategorie.vue?vue&type=script&lang=js"
export * from "./PICMacrocategorie.vue?vue&type=script&lang=js"
import style0 from "./PICMacrocategorie.vue?vue&type=style&index=0&id=674a93dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674a93dc",
  null
  
)

export default component.exports